import React from 'react';
import { fillNoticeText } from './greeting.js';

const NoticeCopy = ({ text, name }) => {
  const blocks = fillNoticeText(text, name)
    .split(/\n\n+/)
    .map(block => block.trim())
    .filter(Boolean);

  return (
    <div className="noticeboard-copy-block">
      {blocks.map((block, index) => {
        const isSignoff = index === blocks.length - 1 && blocks.length > 1;
        return (
          <p
            key={index}
            className={`noticeboard-copy${isSignoff ? ' noticeboard-copy-signoff' : ''}`}
          >
            {block}
          </p>
        );
      })}
    </div>
  );
};

export default NoticeCopy;
